import { render, staticRenderFns } from "./Protection.vue?vue&type=template&id=25610639&"
import script from "./Protection.vue?vue&type=script&lang=js&"
export * from "./Protection.vue?vue&type=script&lang=js&"
import style0 from "./Protection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports